import { RemovableItemOrderType } from "../../../types/enums";

export const PAP_STEP_LABELS = {
  ORDER_TYPE: "Type de commande",
  DETAILS: "Détails",
  MATERIAL: "Matériau",
  AESTHETICS: "Esthétique",
  HOOKS_OPTIONS: "Crochets et options",
  RECAP: "Récapitulatif",
  RDV2_CHOICE: "Choix",
  TRY_IN_FEEDBACK: "Remarques",
};

export const shouldShowPapAestheticsStep = (
  orderType: RemovableItemOrderType | null
): boolean => {
  if (!orderType) return false;

  return [RemovableItemOrderType.TRY_IN, RemovableItemOrderType.FINAL].includes(
    orderType
  );
};

export const getPapStepperLabels = (
  orderType: RemovableItemOrderType | null
): string[] => {
  const baseLabels = [
    PAP_STEP_LABELS.ORDER_TYPE,
    PAP_STEP_LABELS.DETAILS,
    PAP_STEP_LABELS.MATERIAL,
    PAP_STEP_LABELS.AESTHETICS,
    PAP_STEP_LABELS.HOOKS_OPTIONS,
    PAP_STEP_LABELS.RECAP,
  ];

  if (orderType === RemovableItemOrderType.WAX_BITE) {
    return baseLabels.filter(label => label !== PAP_STEP_LABELS.AESTHETICS);
  }

  return baseLabels;
};

export const getPapRdv2StepperLabels = (
  orderType: RemovableItemOrderType | null
): string[] => {
  if (!orderType) {
    return [PAP_STEP_LABELS.RDV2_CHOICE];
  }

  if (orderType === RemovableItemOrderType.WAX_BITE) {
    return [
      PAP_STEP_LABELS.RDV2_CHOICE,
      PAP_STEP_LABELS.MATERIAL,
      PAP_STEP_LABELS.RECAP,
    ];
  }

  return [
    PAP_STEP_LABELS.RDV2_CHOICE,
    PAP_STEP_LABELS.MATERIAL,
    PAP_STEP_LABELS.AESTHETICS,
    PAP_STEP_LABELS.RECAP,
  ];
};
